var angular = require('angular')
require('../../services/search.dataservice.js')
require('../../services/page-wrapper.dataservice.js')
require('../first-letter-frequency/first-letter-frequency.component.js')
require('../../services/app.dataservice.js')

angular.module('AemTransparentAccount')
  .component('accountsTable', {
    template: require('./accounts-table.component.tpl.html'),
    controller: AccountsTableCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

AccountsTableCtrl.$inject = ['transparentAccountService', 'searchDataservice',
  'pageWrapperDataservice', 'textToolsService', '$timeout', '$routeParams',
  'appDataservice', '$location']

function AccountsTableCtrl (transparentAccountService, searchDataservice,
  pageWrapperDataservice, textToolsService, $timeout, $routeParams,
  appDataservice, $location) {
  var vm = this

  vm.$onInit = function () {
    vm.firstLetters = []
    vm.accounts = []
    vm.pagedAccounts = {}
    vm.nextPage = nextPage
    vm.goToAccountDetail = goToAccountDetail
    vm.searched = false

    transparentAccountService.getAllAccounts()
      .then(function (res) {
        searchDataservice.init(res.data.accounts)
        vm.firstLetters = searchDataservice.getFirstLetterFrequency()
        firstPage()
        vm.searched = $routeParams.letter || $routeParams.keyword
      })
      .catch(function (err) {
        appDataservice.state.backendError = err
      })

    $timeout(function () {
      angular.element('#table--sticky--header').stickyTableHeaders()
    })
  }

  function firstPage () {
    if ($routeParams.letter) {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAccountsByNameFirstLetter($routeParams.letter),
        20,
        0)
      vm.accounts = vm.pagedAccounts.items
    } else if ($routeParams.keyword) {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAccountsByKeyword($routeParams.keyword),
        20,
        0)
      vm.accounts = vm.pagedAccounts.items
    } else {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAllAccounts(),
        20,
        0)
      vm.accounts = vm.pagedAccounts.items
    }
  }

  function nextPage () {
    if ($routeParams.letter) {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAccountsByNameFirstLetter($routeParams.letter),
        20,
        vm.pagedAccounts.pageNumber + 1)
      vm.accounts = vm.accounts.concat(vm.pagedAccounts.items)
    } else if ($routeParams.keyword) {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAccountsByKeyword($routeParams.keyword),
        20,
        vm.pagedAccounts.pageNumber + 1)
      vm.accounts = vm.accounts.concat(vm.pagedAccounts.items)
    } else {
      vm.pagedAccounts = pageWrapperDataservice.getPage(
        searchDataservice.getAllAccounts(),
        20,
        vm.pagedAccounts.pageNumber + 1)
      vm.accounts = vm.accounts.concat(vm.pagedAccounts.items)
    }
  }

  function goToAccountDetail (account) {
    var name = textToolsService.removeDiacritics(account.name || '')
    name = name.replace(/[ /]/g, '-')
    name = name ? '/' + name : ''
    $location.path('/' + account.accountNumber + name)
  }
}
